import { render, staticRenderFns } from "./RegisterStep2.vue?vue&type=template&id=140acd9c&scoped=true&"
import script from "./RegisterStep2.vue?vue&type=script&lang=js&"
export * from "./RegisterStep2.vue?vue&type=script&lang=js&"
import style0 from "./RegisterStep2.vue?vue&type=style&index=0&id=140acd9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140acd9c",
  null
  
)

export default component.exports